




















































import { ref, createComponent, Ref, onMounted } from '@vue/composition-api'
import { getUserNotExpiredList, UserNotExpiredItem, NotExpiredItemFile } from '@/service/userNotExpiredList'
import { handlePagination } from '@/service/transferList'
import isElectron from 'is-electron'
import { preTransferHandler, formatFileSize, electronDownload, getDesktopUrl } from '@/helpers/common'
import { transferThreshold } from '@/constant'
import { useRouter } from '../hooks/common'
import { Message } from '@heytap/cook-ui'
import { checkBeforeDownload } from '@/service/public'
export default createComponent({
    setup(props, setupContext) {
        const router = useRouter()
        const unExpiredFileList = ref<UserNotExpiredItem[]>([])
        const selectFiles = ref<UserNotExpiredItem[]>([])
        const downloadFn = async (id, shareIdentify) => {
            const res = await checkBeforeDownload(id, shareIdentify)
            if(res.code === 0 && res.data) {
                const link = document.createElement('a')
                const origin = location.origin
                const userId = setupContext.root.$store.state.publicStore.userId
                link.download = ''
                link.target = '_blank'
                link.href = `${origin}/api/downloadAfterCheck?keyword=${res.data}&userId=${userId}`
                link.click()
            }
        }
        const { currentList, handleCurrentChange, pageSize, currentPageNum, updateCurrentList } = handlePagination(
            unExpiredFileList
        )
        const downloadHandler = async (row: UserNotExpiredItem) => {
            if (isElectron()) {
                const data = {
                    ...row.file,
                    shareIdentify: row.id.split('~')[0],
                }
                electronDownload(data, router)
            } else {
                const params = JSON.stringify(row.file)
                const desktopUrl = getDesktopUrl(params)
                const isContinue = await preTransferHandler({
                    files: row.file,
                    threshold: transferThreshold,
                    url: desktopUrl,
                    transType: 'download',
                })
                if (isContinue) {
                    downloadFn(row.file.id, row.id.split('~')[0])
                }
            }
        }
        const handleSelectionChange = val => {
            selectFiles.value = val
        }
        const downloadAllHandler = async () => {
            if (isElectron()) {
                const files = selectFiles.value.map(item => {
                    return {
                        ...item.file,
                        shareIdentify: item.id.split('~')[0],
                    }
                })
                const res = await (window as any).Ait.fileSystem.addDownloadFiles(files)
                if (res.data) {
                    // router.push("/transferList/download");
                    Message.success('文件下载中，前往下载列表查看')
                }
            } else {
                const files = selectFiles.value.map(item => {
                    return item.file
                })
                const isContinue = await preTransferHandler({
                    files,
                    threshold: transferThreshold,
                    transType: 'download',
                })
                if (isContinue) {
                    selectFiles.value.forEach(async file => {
                        const shareId = file.id.split('~')[0]
                        const fileId = file.id.split('~')[1]
                        downloadFn(fileId, shareId)
                    })
                }
            }
        }
        const goPublic = () => {
            // public中离开路由时保存query的id
            if (sessionStorage.getItem('currentPage')) {
                const currentPage = sessionStorage.getItem('currentPage') as string
                router.push({ path: '/', query: { id: JSON.parse(currentPage).id } })
            } else {
                router.push({ path: '/' })
            }
        }
        onMounted(async () => {
            const res = await getUserNotExpiredList()
            if (res.code === 0) {
                let allFileList = [] as UserNotExpiredItem[]
                res.data.forEach(item => {
                    item.fileList.forEach(file => {
                        const newItem = JSON.parse(JSON.stringify(item))
                        newItem.file = file
                        newItem.id = `${newItem.id}~${file.id}`
                        newItem.fileList = []
                        allFileList.push(newItem)
                    })
                })
                unExpiredFileList.value = allFileList
            } else {
                unExpiredFileList.value = []
            }
            currentPageNum.value = 1
            updateCurrentList()
        })
        return {
            isElectron,
            formatFileSize,
            unExpiredFileList,
            downloadHandler,
            downloadAllHandler,
            currentList,
            handleCurrentChange,
            pageSize,
            handleSelectionChange,
            selectFiles,
            goPublic,
        }
    },
})
